import Cookies from "js-cookie";

const cookieName = "token";

export default {
  isLogged: function() {
    return this.getToken() !== undefined;
  },
  getToken: function() {
    return Cookies.get(cookieName);
  },
  logOut: function() {
    return Cookies.remove(cookieName);
  }
};
